var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',{staticClass:"primary--text"},[_c('router-link',{staticClass:"no-link-style",staticStyle:{"font-weight":"500"},attrs:{"to":{ name: 'Case', params: { case_id: _vm.eventDateObj.caseId} }}},[_vm._v(" "+_vm._s(_vm.eventDateObj.title))]),_vm._v(" "+_vm._s(_vm.message))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }